module.exports = __webpack_public_path__ + "assets/img/translation-case-1.30a28602.png";